import { DependencyContext } from "@revideo/core";
import { FONTS } from "@hudhud/reel/math";

/**
 * Registers the reel's self-hosted fonts with the page before the first frame is drawn. The canvas draws with whatever is in
 * `document.fonts`, so the faces are declared as @font-face rules and their loading is handed to Motion Canvas' dependency
 * tracker, which holds the frame until they are in. A face that fails to load falls back to its stack rather than blocking.
 */
const registered = new Set<string>();

export function ensureFonts(baseUrl: string, families: string[]): void {
  if (typeof document === "undefined") return;
  const wanted = [...new Set(families)].filter((f) => FONTS[f] && !registered.has(f));
  if (!wanted.length) return;
  const css = wanted.flatMap((family) => FONTS[family].faces.map((face) =>
    `@font-face{font-family:"${family}";font-weight:${face.weight};font-display:block;src:url("${baseUrl}/${face.file}") format("truetype");}`)).join("\n");
  const style = document.createElement("style");
  style.setAttribute("data-reel-fonts", wanted.join("|"));
  style.textContent = css;
  document.head.appendChild(style);
  for (const f of wanted) registered.add(f);
  const loads = wanted.flatMap((family) => FONTS[family].faces.map((face) => {
    const weight = FONTS[family].single ? face.weight : String(Math.round((Number(face.weight.split(" ")[0]) + Number(face.weight.split(" ").at(-1))) / 2));
    return document.fonts.load(`${weight} 40px "${family}"`).catch(() => []);
  }));
  DependencyContext.collectPromise(Promise.all(loads).then(() => true), false);
}
